module.exports = {
    null: "מידע לא סופק",
    true: "כן",
    false: "לא",
    date: "תאריך הבדיקה",
    patient_token: "מספר זיהוי למשתמש",
    clinician: "קלינאי מבצע",
    operator: "Healthy.io עוזר ניסוי מתאם",
    gender: "מין",
    age: "גיל",
    background_diseases: "מחלות רקע",
    wound_location: "מיקום הפצע",
    number_of_wounds: "כמות הפצעים",
    wound_appearance_date: "תאריך הופעת הפצע",
    wound_treatment_date: "תאריך תחילת טיפול",
    wound_type: "סוג פצע",
    offensive_smell: "ריח אופנסיבי",
    pain_level: "רמת כאב",
    secretion: "(הפרשה )כמות ואיכות",
    peripheral_pulse: "דפקים פריפריים",
    edema: "בצקת",
    secondary_infection: "סימני זיהום משני",
    temperature: "טמפרטורה",
    wound_length: "(mm) אורך הפצע",
    wound_width: "(mm) רוחב הפצע",
    wound_depth: "(mm) עומק הפצע",
    tissues_segmentation: "רקמות",
    edges: "שוליים",
    pass_treatment: "טיפול קודם",

    "front": "קדמי",
    "back": "אחורי",
    "upper": "עליון",
    "lower": "תחתון",
    "right": "ימין",
    "left": "שמאל",
    "center": "אמצע",
    "foot": "כף רגל",
    "buttock": "עכוז",
    "thigh": "ירך",
    "shin": "שוק",
    "male": "זכר",
    "female": "נקבה",
    "Venous Ulcer" : "כיב ורידי",
    "Arterial Ulcer" : "כיב עורקי",
    "Diabetic/Neuropathic Ulcer" : "כיב סוכרתי\\נוירופתי",
    "Pressure Wound" : "פצע לחץ",
    "Surgical Wound" : "פצע ניתוחי",
    "Other" : "אחר",
    "Insignificant - bandage once a week" : "מעטה- חבישה אחת לשבוע",
    "Intermediate - bandage once every two- to three-days" : "בינונית -חבישה אחת ליומיים-שלושה",
    "Significant - bandage at least once a day" : "רבה - חבישה לפחות אחת ליום",
    "serous clear discharge" : "סרוטית שקופה",
    "yellowish discharge" : "סרוטית צהבהבה",
    "pus discharge" : "סרוטית מוגלתית",
    "pus" : "מוגלתית",
    "sanguinous discharge" : "סרוטית דמית",
    "bloody" : "דמית",
    "Palpable" : "נמושו היטב",
    "Weakened" : "מוחלשים",
    "Absent" : "לא נמושו",
    "Warmer than the rest of the body" : "חם משאר הגוף",
    "Same temperature as the rest of the body" : "כמו שאר הגוף",
    "Cooler than the rest of the body" : "קר משאר הגוף",
    "fibrin" : "פיברין",
    "granulated_undamaged" : "רקמת גרנולציה תקינה",
    "granulated_damaged" : "רקמת גרנולציה לא תקינה",
    "slough" : "Slough",
    "necrotic" : "רקמת נמקית",
    "deep_tissues" : "רקמות עמוקות",
    "FLAT" : "שטחיים",
    "HATORIM" : "חטורים",
    "MESONANIM" : "(מוסננים (מעובים",
    "MATZRITZA" : "(עור ממו-אפיתליזציהסמס (מצרציה",
    "IMRE" : "עם רה"
};


// WEBPACK FOOTER //
// ./src/Dictionary.js